export const formatDate = (dateStr) => {
   if (!dateStr) return '—';
   return new Date(dateStr).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Asia/Kolkata',
   });
};

export const formatTime = (dateStr) => {
   if (!dateStr) return '';
   return (
      new Date(dateStr).toLocaleTimeString('en-US', {
         hour: '2-digit',
         minute: '2-digit',
         hour12: true,
         timeZone: 'Asia/Kolkata',
      }) + ' IST'
   );
};

export const copyToClipboard = async (text) => {
   try {
      if (typeof window !== 'undefined' && navigator.clipboard) {
         await navigator.clipboard.writeText(text);
         return true;
      }
      return false;
   } catch (err) {
      console.error('Failed to copy text: ', err);
      return false;
   }
};
